<template>
  <div id="app">
    <br-header></br-header>
    <router-view />
    <br-footer></br-footer>
  </div>
</template>
<script>
import brHeader from "@/components/common/header";
import brFooter from "@/components/common/footer";
export default {
  components: {
    brHeader,
    brFooter,
  },
};
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
}
#app {
  box-sizing: border-box;
  overflow-x: hidden;
  background-color: #eee;
}
</style>
